export const HIT_LOGINV2 = 'HIT_LOGINV2';
export const GET_LOGINV2 = 'GET_LOGINV2';
